import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { InfoIconComponent } from '../../../icons/info-icon/info-icon.component';
import { Paragraph } from '../../../../../shared/models/internal/popover/paragraph';
import { NgClass } from '@angular/common';
import { AgentActionDirective } from '../../../../directives/agent-action.directive';

@Component({
  selector: 'app-help-popover',
  imports: [InfoIconComponent, NgClass, AgentActionDirective],
  templateUrl: './help-popover.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './help-popover.component.scss',
})
export class HelpPopoverComponent {
  @Input() public paragraphs: Paragraph[] = [];
  @Input() public iconColor = 'text-gray-500';

  public readonly popoverTargetId = `help-popover-${crypto.randomUUID()}`;

  public getTitle(): string {
    return this.paragraphs.length > 0 && this.paragraphs[0].title ? this.paragraphs[0].title! : '';
  }
}
